import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { useAuth0 } from "@auth0/auth0-react";
import Error from "../Error";
import {
  Box,
  Container,
  Grid,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import utils from "../../helpers/utils";
import Loading from "../../components/Loading";
import HttpError from "../../components/HttpError";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBackOutlined";
import { useStyles } from "./styles";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import useHasPermission from "../../hooks/useHasPermission";

const Patient = (props) => {
  document.body.style.backgroundColor = "#F7F7F7";

  const classes = useStyles();

  const { isAuthenticated, user, error } = useAuth0();
  const isAdmin = utils.isAdmin(user);

  const [hasError, setHasError] = useState(false);
  const [patient, setPatient] = useState(null);
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchPatient = async () => {
      // const res = await services.patients.getPatient(props.match.params.id);
      let url = `${process.env.REACT_APP_SERVER_URL}/accounts/patient/${props.match.params.id}/show`;

      const res = await axios.get(url);
      if (res.status === 200) setPatient(res.data);
      else setHasError(true);
    };

    fetchPatient();
    getStates();
  }, [props.match.params?.id]);

  const getStates = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/public/states`,
        method: "get",
      });

      setStates(response.data);
      // setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const { hasPermission } = useHasPermission({ permission: "read:patients" });

  // initial value is null so needs to check the type of the value as well
  if (hasPermission === false) {
    return <Redirect to="/account" />;
  }
  if (isAuthenticated && (props.isProcessing || !props.authUser)) {
    return <Loading />;
  } else if (isAuthenticated && props.isMember === false && !isAdmin) {
    return <Redirect to="/signup" />;
  }
  if (error) {
    return <Error code="500" />;
  }

  if (isAuthenticated && props.isProcessing) {
    return <Loading />;
  } else if (isAuthenticated && props.isMember === false && !isAdmin) {
    return <Redirect to="/signup" />;
  }

  if (error) {
    return <Error code="500" />;
  }

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Grid container direction="row" className={classes.gridWrapper}>
        <div className={classes.headingWrapper}>
          <NavLink className={classes.navLink} to="/patients">
            <ArrowBackIcon className={classes.icon} />
          </NavLink>
          <Typography variant="h5">
            Patient Details
            <div className={classes.divider} />
          </Typography>
        </div>

        <Grid item xs={12}>
          <Box component="div" className={classes.contentSection}>
            {hasError ? (
              <HttpError code="404" />
            ) : (
              <div className={classes.contentWrapper}>
                {!patient && !hasError ? (
                  <div
                    className={`${classes.textCenter} ${classes.loaderWrapper}`}
                  >
                    <CircularProgress size={30} />{" "}
                  </div>
                ) : null}

                {patient ? (
                  <>
                    <div className={classes.textRight}>
                      <Tooltip title="Edit Details">
                        <IconButton
                          component={NavLink}
                          to={`/patient/${props.match.params?.id}/edit`}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <Grid container>
                      <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                        <div className={classes.item}>
                          <Typography className={classes.heading} variant="h6">
                            First Name
                          </Typography>

                          <Typography>
                            {patient?.headOfAccount?.lastName}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                        <div className={classes.item}>
                          <Typography className={classes.heading} variant="h6">
                            Last Name
                          </Typography>

                          <Typography>
                            {patient?.headOfAccount?.lastName}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                        <div className={classes.item}>
                          <Typography className={classes.heading} variant="h6">
                            Email
                          </Typography>

                          <Typography>{patient?.email}</Typography>
                        </div>
                      </Grid>
                      <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                        <div className={classes.item}>
                          <Typography className={classes.heading} variant="h6">
                            Date of Birth
                          </Typography>

                          <Typography>
                            {utils.getFormattedDate(
                              patient?.headOfAccount?.dob,
                              "MM/DD/YYYY"
                            )}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                        <div className={classes.item}>
                          <Typography className={classes.heading} variant="h6">
                            Gender
                          </Typography>

                          <Typography>
                            {patient?.headOfAccount?.gender}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                        <div className={classes.item}>
                          <Typography className={classes.heading} variant="h6">
                            State
                          </Typography>

                          <Typography>
                            {
                              states.find(
                                (s) => s.id === patient?.headOfAccount?.stateId
                              )?.name
                            }
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                ) : null}
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    isProcessing: state.auth0.isProcessing,
    isMember: state.auth0.isMember,
    authUser: state.auth0.user,
  };
};

export default connect(mapStateToProps)(Patient);
